import client from "../utils/client";

function login(data: { email: string; password: string }) {
  return client.post<null, APIResponse<Admin> & { token: string }>("/login", data);
}

const authApi = { login };

export default authApi;
